const CITY_IMAGES = {
  Manchester: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/9f3ae319c_dinosaur-manchester-skyline-1186.webp",
  Liverpool: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/59d2a13ca_generated_image.png",
  London: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/519f0a96a_7.jpg",
  Birmingham: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/e1ab964f2_generated_image.png",
  Leeds: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/9feea35a2_generated_image.png",
  Newcastle: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/cb231aadc_generated_image.png",
  Sheffield: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/c71e0847e_generated_image.png",
  "Stoke-on-Trent": "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/7b53d04b6_StreoAd-260x2004.jpg",
  Chester: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/f359685c2_ThumbnailFeaturedImages1.jpg",
  Stockport: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/870370e5d_generated_image.png",
  Brighton: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/66e8e9486_generated_image.png",
  Essex: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/2368d4f28_generated_image.png",
  Oxford: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/7675b4d3d_generated_image.png",
  Bath: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/6e95de0d6_generated_image.png",
  Slough: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/4134daee7_generated_image.png",
  Southampton: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/4b82e625c_generated_image.png",
  Bristol: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/418999879_generated_image.png",
  Dubai: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/04356ce1d_generated_image.png",
};

const defaultProperties = (city) => [
  { type: "Studio", area: `${city} City Centre`, gr: "£1,100–£1,450", airbnb: "£1,320–£1,870", uplift: "+65% potential" },
  { type: "1 Bedroom", area: `${city} City Centre`, gr: "£1,350–£1,950", airbnb: "£1,650–£2,640", uplift: "+72% potential" },
  { type: "2 Bedroom", area: `${city} City Centre`, gr: "£1,850–£2,750", airbnb: "£2,420–£3,850", uplift: "+75% potential" },
  { type: "3 Bedroom", area: `${city} Suburbs`, gr: "£2,200–£3,400", airbnb: "£2,970–£4,840", uplift: "+80% potential" },
  { type: "4+ Bedroom", area: `${city} Premium Area`, gr: "£3,100–£4,800", airbnb: "£4,180–£6,820", uplift: "+85% potential" },
];

const defaultFaqAnswer = (city) =>
  `Guaranteed rent in ${city} typically ranges from £1,100/month for studios to £4,800+/month for larger homes. The exact figure depends on location, size, condition, and current serviced accommodation demand. Get a free valuation for an accurate offer.`;

const MANCHESTER_PROPERTIES = [
  { type: "Studio", area: "City Centre, Salford Quays", gr: "£1,100–£1,450", airbnb: "£1,320–£1,870", uplift: "+65% potential" },
  { type: "1 Bedroom", area: "Northern Quarter, Ancoats", gr: "£1,350–£1,950", airbnb: "£1,650–£2,640", uplift: "+72% potential" },
  { type: "2 Bedroom", area: "City Centre, Castlefield", gr: "£1,850–£2,750", airbnb: "£2,420–£3,850", uplift: "+75% potential" },
  { type: "3 Bedroom", area: "Didsbury, Chorlton", gr: "£2,200–£3,400", airbnb: "£2,970–£4,840", uplift: "+80% potential" },
  { type: "4+ Bedroom", area: "Hale, Altrincham", gr: "£3,100–£4,800", airbnb: "£4,180–£6,820", uplift: "+85% potential" },
];

const MANCHESTER_FAQ =
  "Guaranteed rent in Manchester typically ranges from £1,100/month for studios to £4,800+/month for larger homes in areas like Hale and Altrincham. The exact figure depends on location, size, condition, and current serviced accommodation demand. Get a free valuation for an accurate offer.";

const CITY_SLUGS = [
  ["Manchester", "manchester"],
  ["Liverpool", "liverpool"],
  ["London", "london"],
  ["Birmingham", "birmingham"],
  ["Leeds", "leeds"],
  ["Newcastle", "newcastle"],
  ["Sheffield", "sheffield"],
  ["Stoke-on-Trent", "stoke-on-trent"],
  ["Chester", "chester"],
  ["Stockport", "stockport"],
  ["Brighton", "brighton"],
  ["Essex", "essex"],
  ["Oxford", "oxford"],
  ["Bath", "bath"],
  ["Slough", "slough"],
  ["Southampton", "southampton"],
  ["Bristol", "bristol"],
  ["Dubai", "dubai"],
];

export const GUARANTEED_RENT_CITIES = CITY_SLUGS.map(([name, slug]) => ({
  name,
  slug,
  country: slug === "dubai" ? "ae" : "gb",
  heroImage: CITY_IMAGES[name],
  properties: name === "Manchester" ? MANCHESTER_PROPERTIES : defaultProperties(name),
  faqAnswer: name === "Manchester" ? MANCHESTER_FAQ : defaultFaqAnswer(name),
}));

export const GENERIC_GR = {
  name: "",
  slug: "",
  country: "gb",
  heroImage: CITY_IMAGES["London"],
  properties: [
    { type: "Studio", area: "City Centre", gr: "£1,100–£1,450", airbnb: "£1,320–£1,870", uplift: "+65% potential" },
    { type: "1 Bedroom", area: "City Centre", gr: "£1,350–£1,950", airbnb: "£1,650–£2,640", uplift: "+72% potential" },
    { type: "2 Bedroom", area: "City Centre", gr: "£1,850–£2,750", airbnb: "£2,420–£3,850", uplift: "+75% potential" },
    { type: "3 Bedroom", area: "Suburban Area", gr: "£2,200–£3,400", airbnb: "£2,970–£4,840", uplift: "+80% potential" },
    { type: "4+ Bedroom", area: "Premium Area", gr: "£3,100–£4,800", airbnb: "£4,180–£6,820", uplift: "+85% potential" },
  ],
  faqAnswer:
    "Guaranteed rent typically ranges from £1,100/month for studios to £4,800+/month for larger homes. The exact figure depends on location, size, condition, and current serviced accommodation demand. Get a free valuation for an accurate offer.",
};

export function getCity(slug) {
  return GUARANTEED_RENT_CITIES.find((c) => c.slug === slug);
}